import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AsyncState } from '@cawita/core-front/state';
import { SubSink } from 'subsink';
import { Stay } from '@shared/models';
import { StayState, StayStore } from '../stay.store';

export interface IfActiveStayContext { $implicit: Stay; }

@Directive({ selector: '[cwtIfActiveStay]' })
export class IfActiveStayDirective implements OnInit, OnDestroy {
    private sub = new SubSink();
    private ctx: IfActiveStayContext = { $implicit: null };

    @Input('cwtIfActiveStayElse') else?: TemplateRef<any>; 

    constructor(
        protected store: StayStore,
        protected tRef: TemplateRef<IfActiveStayContext>,
        protected vcRef: ViewContainerRef,
        protected cdRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.sub.sink = this.store.state$.subscribe((state) => this._onStateChange(state));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private _onStateChange(state: StayState & AsyncState) {
        this.vcRef.clear();
        if(state.activeStay) {
          this.ctx.$implicit = state.activeStay;
          const ref = this.vcRef.createEmbeddedView(this.tRef, this.ctx);
          ref.detectChanges();
        } else if(this.else) {
          const ref = this.vcRef.createEmbeddedView(this.else, {});
          ref.detectChanges();
        }
    }
}